<nz-card nzTitle="Technical Review" [nzExtra]="extraTpl">
  <ng-container *ngIf="error$ | async as errorMsg; else resultTpl">
    <nz-result
      nzStatus="error"
      nzTitle="SharePoint gave an error"
      [nzSubTitle]="errorMsg"
    ></nz-result>
  </ng-container>
</nz-card>

<ng-template #extraTpl>
  <!-- Use stopPropagation so the panel doesn't toggle when clicking the link -->
  <a target="_blank" rel="external" [href]="siteUrl" (click)="$event.stopPropagation()">
    <i nz-icon nzType="link"></i>
    Open SharePoint Site
  </a>
</ng-template>

<ng-template #resultTpl>
  <nz-skeleton [nzActive]="true" [nzLoading]="(designLoading$ | async) ?? false">
    <nz-table
      #trTable
      [nzData]="(technicalReviewDocuments$ | async) ?? []"
      [nzLoading]="technicalReviewLoading$ | async"
      nzSize="small"
      nzShowPagination="false"
    >
      <thead>
        <tr>
          <th>Name</th>
        </tr>
      </thead>
      <tbody class="em-no-table-row-hover">
        <ng-container *ngFor="let item of trTable.data; trackBy: trackByRef">
          <tr>
            <td>
              <a target="_blank" rel="external" [href]="item.webUrl">
                <i nz-icon nzType="link"></i>
                {{ item.name }}
              </a>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </nz-skeleton>
</ng-template>
